import { render } from "./OneClick.vue?vue&type=template&id=34f3db60"
import script from "./OneClick.vue?vue&type=script&lang=js"
export * from "./OneClick.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__